import { checkParams, newSearchURL } from "./../../components/Utils";

export const handleRangeTertiaryColor = (ev, state, props) => {
  const {
    primaryColorSelected,
    secondaryColorSelected,
    wizardPrimaryColors
  } = state;
  const { history, match, location } = props;

  const tertiaryColorParam = checkParams("tertiary-color", location);
  const stepParam = checkParams("step", location);

  let tertiaryColorSelected = "0,0";

  if (ev) {
    tertiaryColorSelected = ev.target.value;
  } else if (tertiaryColorParam) {
    tertiaryColorSelected = tertiaryColorParam;
  }

  if (stepParam && stepParam !== "1") {
    history.push(`/${match.params.wizardId}${location.search}`);
  } else if (!tertiaryColorParam) {
    /**
     * If not exist tertiaryColorParam in URL, put a default value
     */
    history.push(
      `/${match.params.wizardId}?primary-color=${primaryColorSelected}&secondary-color=${secondaryColorSelected}&tertiary-color=${tertiaryColorSelected}&step=1`
    );
  } else {
    /**
     * If the colors params exist, just change the values in URL for keep other params
     */
    const primaryColorURLValue =
      location && checkParams("primary-color", location);

    const newURLPrimaryColor = newSearchURL(
      `primary-color=${primaryColorURLValue}`,
      `primary-color=${primaryColorSelected}`,
      location
    );

    const secondaryColorURLValue =
      location && checkParams("secondary-color", location);

    let newURLPrimaryColorLocation = {
      search: newURLPrimaryColor
    };

    const newURLSecondaryColor = newSearchURL(
      `secondary-color=${secondaryColorURLValue}`,
      `secondary-color=${secondaryColorSelected}`,
      newURLPrimaryColorLocation
    );

    const tertiaryColorURLValue =
      location && checkParams("tertiary-color", location);

    let newURLSecondaryColorLocation = {
      search: newURLSecondaryColor
    };

    const newURLWithValuesChanged = newSearchURL(
      `tertiary-color=${tertiaryColorURLValue}`,
      `tertiary-color=${tertiaryColorSelected}`,
      newURLSecondaryColorLocation
    );

    history.push(`/${match.params.wizardId}${newURLWithValuesChanged}`);
  }

  const colorsPrimary =
    wizardPrimaryColors && wizardPrimaryColors[primaryColorSelected];
  let colorsSecondary = null;
  let colorsTertiary = null;

  if (colorsPrimary) {
    colorsSecondary =
      colorsPrimary.wizard_colors_secondary_repeater[secondaryColorSelected];

    if (colorsSecondary) {
      colorsTertiary = colorsSecondary.wizard_colors_tertiary_repeater_row;
    }
  }

  return {
    tertiaryColorSelected,
    colorsTertiary
  };
};
